module.exports = {
  translations: {
    // metamask
    'metamask.pleaseInstallFirst': 'Please install MetaMask first!',
    'metamask.youNeedSignMessage': 'You need to sign the message to be able to use system!',
    // award
    'award.pleaseSignIn': '请进行登录以便获取您的礼物。',
    'award.signInTwitter': '使用Twitter（推特）账户登录',
    'award.congratulation': '恭喜您！',
    'award.openLinkBelow': '请在智能手机点击下面的URL获取哑剧彩票。',
    'award.gotoTheLottery': '从专用应用程序进入抽奖场所，并请享受您喜爱的商品抽奖吧。',
    'award.termOf': '推特关注&转发活动的规章',
    'award.sorry': '非常抱歉。',
    'award.campaignHasEnded': '您不符合条件要求或活动期限已过期。'
  }
}